import { concatClasses } from "../../../helpers/concatClasses/index.js";
const defaultType = "info";
function capitalizeFirstLetter(str) {
  if (str.length === 0)
    return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
}
const getDefaultTitle = (type) => {
  if (!type) {
    return capitalizeFirstLetter(defaultType);
  }
  return capitalizeFirstLetter(type);
};
const getContainerClasses = (props) => {
  const classes = [
    "relative",
    "flex",
    "min-w-320",
    "flex-grow",
    "flex-row",
    "rounded-sm",
    "text-neutral-700",
    "bg-neutral-0",
    "shadow-l"
  ];
  if (props.dsf_clickable) {
    classes.push("hover:cursor-pointer");
  }
  return concatClasses(classes);
};
const bgColorClassMap = {
  info: "bg-secondary-200",
  success: "bg-success-200",
  warning: "bg-primary-200",
  error: "bg-error-200",
  default: "bg-neutral-200",
  attention: "bg-warning-200"
};
const getBackgroundColorClass = (type) => {
  if (!type || !bgColorClassMap[type]) {
    return bgColorClassMap[defaultType];
  }
  return bgColorClassMap[type];
};
const iconNames = {
  info: "Info",
  success: "Check",
  warning: "AlertTriangle",
  error: "X",
  default: "User",
  attention: "X"
};
const getIconName = (type) => {
  if (!type || !iconNames[type]) {
    return iconNames[defaultType];
  }
  return iconNames[type];
};
export {
  getBackgroundColorClass,
  getContainerClasses,
  getDefaultTitle,
  getIconName
};
